import { render } from "./ImportacaoRetornoBancarioModal.vue?vue&type=template&id=231d238f&scoped=true&ts=true"
import script from "./ImportacaoRetornoBancarioModal.vue?vue&type=script&lang=ts"
export * from "./ImportacaoRetornoBancarioModal.vue?vue&type=script&lang=ts"

import "./ImportacaoRetornoBancarioModal.vue?vue&type=style&index=0&id=231d238f&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231d238f"]])

export default __exports__